import { Injectable } from "@angular/core";
import { FirestoreV9Service } from "../../services";
import { DocumentData, FirestoreDataConverter } from "firebase/firestore";
import { Observable } from "rxjs";

interface BuildsDashboardModel {
  workOrderList: WorkOrderListDocumentModel;
}

interface WorkOrderListDocumentModel {
  items: string[];
}

@Injectable({
  providedIn: "root",
})
export class ShopDashboardCollection extends FirestoreV9Service<BuildsDashboardModel> {
  protected override basePath = "shop-dashboards";
  protected override baseConverter!: FirestoreDataConverter<BuildsDashboardModel, DocumentData>;

  workOrderList$ = this.doc$("workOrderList") as unknown as Observable<WorkOrderListDocumentModel>;

  updateWorkOrderList(updatedArray: string[]) {
    return this.upsert(
      "workOrderList",
      {
        items: updatedArray,
      } as Partial<BuildsDashboardModel>
    );
  }
}
